import { deDE, enUS } from "@mui/x-data-grid-pro";
export const tableLangs : {[char: string]: any} = { en: enUS.components.MuiDataGrid.defaultProps.localeText, de: deDE.components.MuiDataGrid.defaultProps.localeText };
export const defaultAppLang = 'en';
export const INITIAL_FIELD_STATE = { value: '', dirty: false, error: false };
export const BUTTON_SIZE = 'calc(1.75em + 12px)';